import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


export default new Router({
  routes: [{
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      hidden: false,
      title: "登录",
      allowBack: false
    },
    component: () => import('@/view/login/index.vue')
  },
  //学生
  {
    path: '/student',
    name: 'student',
    component: () => import('@/layout/StudentLayout.vue'),
    redirect: '/student/home',
    children: [
      {
        path: 'home',
        name: 'student-home',
        component: () => import('@/view/student/home/index.vue'),
        meta: {
          title: '课程'
        }
      },
      {
        path: '/u3d/:file/:key/:query',
        name: 'u3d',
        meta: { title: '仿真实训-课程' },
        component: () => import('@/view/U3d/index.vue')
      },
    ]
  },
  //老师
  {
    path: '/teacher',
    name: 'teacher',
    component: () => import('@/layout/TeacherLayout.vue'),
    redirect: '/teacher/fangzhen/course',
    children: [
      //仿真实训-课程
      {
        path: 'fangzhen/course',
        name: 'teacher-fangzhen-course',
        component: () => import('@/view/teacher/fangzhen/course/index.vue'),
        meta: {
          title: '课程',
          rootPath: 'fangzhen',
          navPath: 'course'
        }
      },
      //仿真实训-任务
      {
        path: 'fangzhen/task',
        name: 'teacher-fangzhen-task',
        component: () => import('@/view/teacher/fangzhen/task/index.vue'),
        meta: {
          title: '任务',
          rootPath: 'fangzhen',
          navPath: 'task'
        }
      },
      //仿真实训-课程详情
      {
        path: 'fangzhen/course-details',
        name: 'teacher-course-details',
        component: () => import('@/view/teacher/fangzhen/course-details/index.vue'),
        meta: {
          title: '课程详情',
          rootPath: 'fangzhen',
          navPath: 'course'
        }
      },
      //系统管理-班级
      {
        path: 'system/class',
        name: 'system-class',
        component: () => import('@/view/teacher/system/class/index.vue'),
        meta: {
          title: '班级管理',
          rootPath: 'system'
        }
      },
    ]
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js